import { useState } from 'react';

const testimonials = [
  {
    name: '张明远',
    role: '技术总监',
    company: '星辰科技',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20portrait%20of%20middle-aged%20man%20in%20dark%20suit%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20background%2C%20corporate%20headshot%20style%2C%20friendly%20confident%20expression&width=200&height=200&seq=avatar-1-fs&orientation=squarish',
    rating: 4.9,
    quote: 'Tianyi 彻底改变了我们团队的协作方式。以前文件散落在各个地方，现在所有文档都有条不紊地管理着，版本回溯功能救了我们无数次。',
  },
  {
    name: '林悦然',
    role: '运营主管',
    company: '蓝鲸互动',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20woman%20portrait%20in%20modern%20office%20attire%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20background%2C%20corporate%20headshot%20style%2C%20confident%20smile&width=200&height=200&seq=avatar-2-fs&orientation=squarish',
    rating: 4.8,
    quote: '权限管理功能太强了！我们公司有多个部门协同工作，不同层级的权限设置让信息既能高效流通又能安全可控。',
  },
  {
    name: '陈志远',
    role: 'CEO',
    company: '远帆数据',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20executive%20portrait%20in%20formal%20attire%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20background%2C%20corporate%20headshot%20style%2C%20authoritative%20yet%20approachable%20expression&width=200&height=200&seq=avatar-3-fs&orientation=squarish',
    rating: 5.0,
    quote: '作为一家数据公司，我们对文件安全的重视程度极高。Tianyi 的加密传输和审计日志让我们完全放心地把核心数据放在上面。',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-label text-xs md:text-sm font-medium tracking-widest text-foreground-500 uppercase mb-3">
          客户心声
        </p>
        <h3 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-10 md:mb-14">
          他们都在用<span className="italic">Tianyi</span>
        </h3>

        <div className="relative">
          <div className="flex items-center justify-center gap-1.5 mb-8">
            <span className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs font-medium">
              <i className="ri-star-fill text-amber-400 text-xs"></i>
              {t.rating} / 5.0
            </span>
          </div>

          <blockquote className="font-heading text-xl md:text-3xl font-medium text-foreground-800 leading-relaxed italic px-4">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="mt-10 flex items-center justify-center gap-3">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden bg-background-200">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
              <p className="text-xs text-foreground-500">
                {t.role}，{t.company}
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-10">
            <button
              className="w-10 h-10 md:w-12 md:h-12 rounded-xl border border-foreground-200 flex items-center justify-center text-foreground-600 hover:border-foreground-400 hover:text-foreground-900 transition-all cursor-pointer"
              onClick={() =>
                setCurrent((prev) =>
                  prev === 0 ? testimonials.length - 1 : prev - 1
                )
              }
            >
              <i className="ri-arrow-left-line text-lg"></i>
            </button>
            <button
              className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
              onClick={() =>
                setCurrent((prev) =>
                  prev === testimonials.length - 1 ? 0 : prev + 1
                )
              }
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          <div className="flex items-center justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === current
                    ? 'bg-foreground-900 w-6'
                    : 'bg-foreground-300 hover:bg-foreground-400'
                }`}
                onClick={() => setCurrent(i)}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}